import { regexBase64 } from '@utils/regexes';

export const checkIsStringBase64Encoded = (string: string) =>
  regexBase64.test(string);
